import React, { useMemo } from 'react';
import type EasyMDE from 'easymde';
import SimpleMDEEditor from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';

type RichTextEditorProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  className?: string;
  id?: string;
};

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  label,
  required,
  className,
  id,
}) => {
  const options = useMemo<EasyMDE.Options>(
    () => ({
      spellChecker: false,
      toolbar: [
        'heading',
        'bold',
        'italic',
        'strikethrough',
        '|',
        'unordered-list',
        'ordered-list',
        '|',
        'link',
        '|',
        'preview',
      ],
      status: false,
      minHeight: '120px',
    }),
    []
  );

  return (
    <div className={`flex flex-col gap-2 ${className || ''}`}>
      {label && (
        <label
          className="break-words text-footnote1 capitalize leading-[16px] text-N700 text-text-secondary"
          htmlFor={id}
        >
          {label}
          {required && <span className="text-text-danger">*</span>}
        </label>
      )}
      <SimpleMDEEditor id={id} value={value} onChange={onChange} options={options} />
    </div>
  );
};

export { RichTextEditor };
